var map = {
	"./demos/attachments/index.ts": 61283,
	"./demos/basic/index.ts": 97626,
	"./demos/customContent/index.ts": 688,
	"./demos/loading/index.ts": 10268,
	"./demos/shape/index.ts": 37402,
	"./demos/streaming/index.ts": 22964,
	"./demos/typing/index.ts": 65498,
	"./demos/variant/index.ts": 22203,
	"./demos/withThink/index.ts": 83845,
	"./demos/xmarkdown/index.ts": 12356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9584;